/** Jakość (reklamacje, analityka, zdarzenia jakościowe, dostawcy) — słowniki pod `qual.*`. */
export const qualPl = {
  nav: {
    group: 'Jakość',
    complaints: 'Reklamacje',
    analytics: 'Analityka reklamacji',
    events: 'Zdarzenia jakościowe',
    suppliers: 'Dostawcy',
    overview: 'Pulpit jakości',
  },
  common: {
    all: 'Wszystkie',
    clear: 'Wyczyść filtry',
    from: 'Od',
    to: 'Do',
    search: 'Szukaj',
    sample: 'dane przykładowe',
    empty: 'Brak danych dla wybranych filtrów.',
    error: 'Nie udało się pobrać danych.',
    retry: 'Spróbuj ponownie',
    save: 'Zapisz',
    cancel: 'Anuluj',
    remove: 'Usuń',
    lookupPh: 'Wpisz, aby wyszukać…',
    customer: 'Klient',
    owner: 'Handlowiec',
    product: 'Towar',
    supplier: 'Dostawca',
    category: 'Przyczyna',
    source: 'Źródło',
    status: 'Status',
    date: 'Data',
    value: 'Wartość',
    quantity: 'Ilość',
    count: 'Liczba',
    sales: 'Sprzedaż',
    share: 'Udział',
    prev: 'Poprzednia',
    next: 'Następna',
    page: 'Strona {page} z {pages}',
    range: '{from}–{to} z {total}',
    emptyHint: 'Zmień okres albo wyczyść filtry.',
    vsPrevious: 'vs poprzedni okres',
    days: '{count} dni',
    seeAll: 'Zobacz wszystkie',
    open: 'Otwórz',
  },
  status: {
    OPEN: 'Nowa',
    IN_PROGRESS: 'W analizie',
    ACCEPTED: 'Uznana',
    REJECTED: 'Odrzucona',
    CLOSED: 'Zamknięta',
  },
  source: {
    CORRECTION: 'Korekta (KFS)',
    DRIVER: 'Kierowca / dostawa',
    MANUAL: 'Wpis ręczny',
  },
  category: {
    QUALITY: 'Jakość',
    MISSING_IN_DELIVERY: 'Brak w dostawie',
    MISSING_ON_DOCUMENT: 'Brak na dokumencie',
    WEIGHT_QUANTITY: 'Waga / ilość',
    WRONG_PRODUCT: 'Pomyłka towarowa',
    EXPIRY_DATE: 'Termin przydatności',
    PRICE: 'Cena',
    OTHER: 'Inne',
  },
  complaints: {
    title: 'Reklamacje',
    description: 'Rejestr reklamacji: korekty sprzedaży z przyczyną, błędy w dostawach i wpisy ręczne. Status obsługi prowadzony w NEXOPS — nie zmienia ERP.',
    kpiCount: 'Reklamacje',
    kpiValue: 'Wartość',
    kpiOpen: 'Nowe',
    kpiProgress: 'W analizie',
    searchPh: 'Numer korekty, klient, opis…',
    reference: 'Dokument',
    detailTitle: 'Reklamacja {ref}',
    lines: 'Pozycje korekty',
    reason: 'Przyczyna korekty',
    net: 'Netto',
    noLines: 'Reklamacja bez pozycji korekty (błąd w dostawie lub wpis ręczny).',
    supplierFrom: 'PZ z {date}',
    noSupplier: 'brak PZ przed sprzedażą',
    saleDate: 'Data sprzedaży',
    route: 'Trasa',
    driver: 'Kierowca',
    vehicle: 'Pojazd',
    document: 'Dokument źródłowy',
    descriptionLabel: 'Opis',
    history: 'Historia obsługi',
    noHistory: 'Status nie był zmieniany w NEXOPS.',
    changeStatus: 'Zmień status',
    newStatus: 'Nowy status',
    comment: 'Komentarz',
    commentRequired: 'Komentarz jest wymagany przy odrzuceniu.',
    statusSaved: 'Status zapisany.',
    monthClosed: 'Miesiąc zamknięty w raporcie zarządu — zmiana statusu nie zmienia zamrożonego raportu.',
    erpNote: 'Status obsługi nie jest zapisywany w InsERT.',
    handledBy: 'Obsługuje: {name}',
    caseCol: 'Reklamacja',
    kpiAvgHint: 'średnio {value}',
    insightWaiting: '{count} reklamacji czeka na obsługę (nowe i w analizie).',
    showOpen: 'Pokaż nowe',
    allOfCustomer: 'Wszystkie reklamacje klienta',
    linesTotal: 'Razem pozycje',
    mixTitle: 'Struktura przyczyn',
    mixHint: 'Kliknij przyczynę, aby zawęzić listę; kliknij ponownie, aby zdjąć filtr.',
    ageCol: 'Wiek',
    sortBy: 'Sortuj wg: {column}',
    selectAll: 'Zaznacz wszystkie na stronie',
    selectRow: 'Zaznacz reklamację',
    selected: 'Zaznaczono: {count}',
    bulkTitle: 'Zmień status zaznaczonych',
    bulkApply: 'Zmień status',
    bulkDone: 'Zmieniono: {updated}, pominięto: {skipped}.',
    bulkSkippedHint: 'Pominięte, gdy bieżący status nie pozwala na tę zmianę albo sprawa zmieniła się w międzyczasie.',
    bulkClear: 'Odznacz',
    prevCase: 'Poprzednia reklamacja',
    nextCase: 'Następna reklamacja',
    position: '{index} z {count} na stronie',
    quickStatus: 'Szybka zmiana statusu',
    openFor: 'czeka {count} dni',
  },
  analytics: {
    title: 'Analityka reklamacji',
    description: 'Reklamacje w czasie, udział w sprzedaży (wg faktur, z paragonami stałych klientów), produkty, przyczyny, klienci i koszt wg dostawcy towaru.',
    kpiShare: 'Udział w sprzedaży',
    kpiSales: 'Sprzedaż netto',
    receiptsHint: 'w tym paragony {value}',
    trend: 'Reklamacje w czasie',
    trendValue: 'Wartość reklamacji',
    trendShare: 'Udział w sprzedaży (%)',
    byCategory: 'Wg przyczyny',
    bySource: 'Wg źródła',
    products: 'Najczęściej reklamowane produkty',
    complaintsCol: 'Korekty',
    pctOfSales: '% sprzedaży towaru',
    customers: 'Klienci z największą wartością reklamacji',
    suppliers: 'Koszt reklamacji wg dostawcy towaru',
    suppliersHint: 'Dostawca = ostatnie przyjęcie PZ towaru przed datą sprzedaży. Wartość = pozycje korekt z przyczyną.',
    unknownSupplier: 'Bez PZ przed sprzedażą',
    linesCol: 'Pozycje',
    productsCol: 'Towary',
    trendHint: 'Słupki: wartość reklamacji · linia: udział w sprzedaży netto.',
    drillHint: 'Kliknij przyczynę, aby zobaczyć te reklamacje w rejestrze.',
    bySourceHint: 'Skąd pochodzi reklamacja: korekta w ERP, zgłoszenie z trasy albo wpis ręczny.',
    productsHint: 'Pozycje korekt z przyczyną, bez usług (bonusy, retro). Kliknij wiersz, aby przejść do rejestru.',
    pctOfSalesShort: '% sprzedaży',
    casesCount: '{count} rekl.',
    insightTop: 'Najwięcej kosztuje przyczyna „{category}” — {share} wartości reklamacji w okresie.',
    showInRegister: 'Pokaż w rejestrze',
    deltaHint: 'vs {from} – {to}',
    paretoTitle: 'Pareto towarów (80/20)',
    paretoHint: '{top} z {products} reklamowanych towarów ({share}) daje 80% kosztu reklamacji.',
    paretoCum: 'Skumulowany udział',
    heatTitle: 'Przyczyny miesiąc po miesiącu',
    heatHint: 'Im ciemniejsza komórka, tym większa wartość. Kliknij komórkę, aby otworzyć te reklamacje w rejestrze.',
    heatValue: 'Wartość',
    heatCount: 'Liczba',
    ownersTitle: 'Handlowcy',
    ownersHint: 'Reklamacje klientów handlowca i ich udział w sprzedaży tych klientów.',
    noOwner: 'Klienci bez opiekuna',
    customersCol: 'Klienci',
  },
  events: {
    title: 'Zdarzenia jakościowe',
    description: 'Przebieranie partii przy przyjęciu („przebierak”), reklamacje do dostawców, zdarzenia w procesie — z ilością odrzuconą i działaniem korygującym.',
    add: 'Nowe zdarzenie',
    edit: 'Edytuj zdarzenie',
    type: 'Typ',
    checked: 'Sprawdzono',
    rejected: 'Odrzucono',
    rejectedPct: '% odrzutu',
    unit: 'Jedn.',
    descriptionLabel: 'Opis',
    cause: 'Przyczyna',
    action: 'Działanie korygujące',
    responsible: 'Odpowiedzialny',
    productName: 'Towar spoza katalogu',
    kpiOpen: 'Otwarte',
    kpiProgress: 'W toku',
    kpiClosed: 'Zamknięte',
    kpiRejected: 'Odrzucona ilość',
    kpiSorting: 'Przebrane partie',
    descriptionRequired: 'Opis jest wymagany (min. 3 znaki).',
    removeConfirm: 'Usunąć zdarzenie?',
    sortingHint: 'Przebierak: zapisz ilość sprawdzoną i odrzuconą — procent odrzutu policzy się sam.',
    searchPh: 'Opis, przyczyna, działanie…',
    eventCol: 'Zdarzenie',
    productSupplier: 'Towar / dostawca',
    rejectedCol: 'Odrzut',
    rejectedOf: '{rejected} z {checked}',
    actionShort: 'Działanie',
    emptyHint: 'Zapisz pierwsze zdarzenie — np. przebieranie partii przy przyjęciu.',
    badNumber: 'Ilości muszą być liczbami nieujemnymi.',
    tooMany: 'Odrzucono więcej, niż sprawdzono — popraw ilości.',
    viewList: 'Lista',
    viewBoard: 'Tablica',
    trendTitle: 'Zdarzenia w czasie',
    trendHint: 'Słupki: zdarzenia wg typu · linia: % odrzutu przy przyjęciu.',
    noActionPill: 'Bez działania korygującego',
    kpiNoAction: 'Bez działania',
    kpiRejectedPct: 'Odrzut przy przyjęciu',
    openFor: 'otwarte {count} d',
    moveTo: 'Przenieś: {status}',
    moved: 'Zdarzenie przeniesione.',
    boardEmpty: 'Brak zdarzeń',
    boardTruncated: 'Tablica pokazuje {shown} najnowszych z {total} — zawęź filtry.',
    needsAction: 'brak działania korygującego',
  },
  eventType: {
    RECEIPT_SORTING: 'Przebieranie przy przyjęciu',
    SUPPLIER_COMPLAINT: 'Reklamacja do dostawcy',
    PROCESS: 'Zdarzenie w procesie',
    OTHER: 'Inne',
  },
  eventStatus: {
    OPEN: 'Otwarte',
    IN_PROGRESS: 'W toku',
    CLOSED: 'Zamknięte',
  },
  suppliers: {
    title: 'Dostawcy',
    description: 'Koszt reklamacji przypisany dostawcy towaru, zdarzenia jakościowe i uzgodnienia z dostawcą (feedback po reklamacjach).',
    searchPh: 'Szukaj dostawcy…',
    complaintValue: 'Koszt reklamacji',
    events: 'Zdarzenia',
    notes: 'Uzgodnienia',
    lastReceipt: 'Ostatnie PZ',
    lastNote: 'Ostatnie uzgodnienie',
    open: 'Uzgodnienia',
    notesTitle: 'Uzgodnienia: {name}',
    noNotes: 'Brak uzgodnień z tym dostawcą.',
    addNote: 'Dodaj wpis',
    kind: 'Rodzaj',
    text: 'Treść',
    followUp: 'Termin sprawdzenia',
    textRequired: 'Treść jest wymagana (min. 3 znaki).',
    kpiCost: 'Koszt reklamacji',
    costShort: 'Koszt',
    kpiWithCost: 'Dostawcy z reklamacjami',
    kpiOf: 'z {count} aktywnych w okresie',
    insightTop: '{name} odpowiada za {share} kosztu reklamacji w okresie.',
    lastReceiptShort: 'ostatnie PZ {date}',
    noReceipt: 'brak PZ',
    ofTotal: '{share} całości',
    showEvents: 'Zdarzenia jakościowe tego dostawcy',
    textPh: 'Co ustalono z dostawcą, np. przebieranie partii przed wysyłką…',
    noteSaved: 'Wpis dodany.',
    removeConfirm: 'Usunąć wpis?',
    kpiPurchases: 'Zakupy (PZ)',
    kpiCostPct: 'Koszt / zakupy',
    purchasesCol: 'Zakupy PZ',
    costPctCol: 'Koszt / zakupy',
    rejectedPctCol: 'Odrzut',
    gradeCol: 'Ocena',
    gradeHint: 'Ocena = gorszy z dwóch wymiarów: koszt reklamacji jako % zakupów (A < 1%, B < 2,5%, C < 5%; liczony od 10 tys. zł zakupów w okresie) i % odrzutu przy przyjęciu (A < 2%, B < 5%, C < 10%).',
    quadrantTitle: 'Mapa dostawców',
    quadrantHint: 'Dostawcy z zakupami od 10 tys. zł. Oś pozioma: zakupy w okresie (skala log.) · pionowa: koszt reklamacji jako % zakupów · wielkość: koszt. Kliknij punkt, aby otworzyć dostawcę.',
    profileTrend: 'Zakupy i koszt reklamacji w czasie',
    profileProducts: 'Reklamowane towary tego dostawcy',
    profileEvents: 'Ostatnie zdarzenia',
    noProducts: 'Brak reklamowanych towarów w okresie.',
    receiptsCount: '{count} PZ',
    overdueCount: '{count} po terminie',
    nextFollowUp: 'termin {date}',
    tabOverview: 'Przegląd',
    tabNotes: 'Uzgodnienia',
    insightGrade: '{count} dostawców ma ocenę D (krytyczną) w okresie.',
    showGradeD: 'Pokaż ocenę D',
  },
  noteKind: {
    NOTE: 'Notatka',
    AGREEMENT: 'Ustalenie',
  },
  overview: {
    title: 'Pulpit jakości',
    description: 'Co wymaga uwagi teraz: reklamacje do obsługi, zdarzenia otwarte, terminy ustaleń z dostawcami i to, co rośnie względem poprzedniego okresu.',
    kpiBacklog: 'Do obsługi',
    backlogValue: 'wartość {value}',
    backlogTitle: 'Kolejka do obsługi',
    backlogHint: 'Reklamacje nowe i w analizie (z każdego okresu), najstarsze najpierw.',
    backlogEmpty: 'Wszystkie reklamacje są obsłużone.',
    showBacklog: 'Cała kolejka w rejestrze',
    trendTitle: 'Wartość reklamacji i udział w sprzedaży',
    categoriesTitle: 'Przyczyny: teraz i poprzednio',
    categoriesHint: 'Pasek = bieżący okres, znacznik = poprzedni okres tej samej długości.',
    moversTitle: 'Co rośnie',
    moversHint: 'Największy przyrost wartości reklamacji względem poprzedniego okresu.',
    moversProducts: 'Towary',
    moversCustomers: 'Klienci',
    moversEmpty: 'Nic nie rośnie względem poprzedniego okresu.',
    was: 'było {value}',
    eventsTitle: 'Zdarzenia otwarte',
    eventsHint: 'Najstarsze otwarte i w toku · {count} bez działania korygującego.',
    eventsEmpty: 'Brak otwartych zdarzeń.',
    rejectedPeriod: 'Odrzut przy przyjęciu w okresie: {value}',
    followUpsTitle: 'Terminy ustaleń z dostawcami',
    followUpsHint: 'Po terminie i na najbliższe 14 dni. Termin jest załatwiony, gdy u dostawcy pojawi się nowszy wpis.',
    followUpsEmpty: 'Brak terminów do pilnowania.',
    overdue: 'po terminie {count} d',
    dueToday: 'dziś',
    dueIn: 'za {count} d',
    insightAging: '{count} reklamacji czeka na obsługę ponad 30 dni.',
    insightUp: 'Udział reklamacji w sprzedaży wzrósł o {delta} względem poprzedniego okresu.',
    insightDown: 'Udział reklamacji w sprzedaży spadł o {delta} względem poprzedniego okresu.',
    showQueue: 'Pokaż kolejkę',
    goAnalytics: 'Analityka',
    goComplaints: 'Rejestr reklamacji',
    goEvents: 'Zdarzenia',
    goSuppliers: 'Dostawcy',
  },
  aging: {
    D0_7: 'do 7 dni',
    D8_30: '8–30 dni',
    D31_90: '31–90 dni',
    D90_PLUS: 'ponad 90 dni',
  },
  grade: {
    A: 'Bardzo dobry',
    B: 'Dobry',
    C: 'Do poprawy',
    D: 'Krytyczny',
    none: 'Bez oceny',
  },
};

type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

export const qualEn: Shape<typeof qualPl> = {
  nav: {
    group: 'Quality',
    complaints: 'Complaints',
    analytics: 'Complaint analytics',
    events: 'Quality events',
    suppliers: 'Suppliers',
    overview: 'Quality dashboard',
  },
  common: {
    all: 'All',
    clear: 'Clear filters',
    from: 'From',
    to: 'To',
    search: 'Search',
    sample: 'sample data',
    empty: 'No data for the selected filters.',
    error: 'Could not load the data.',
    retry: 'Try again',
    save: 'Save',
    cancel: 'Cancel',
    remove: 'Delete',
    lookupPh: 'Type to search…',
    customer: 'Customer',
    owner: 'Sales rep',
    product: 'Product',
    supplier: 'Supplier',
    category: 'Reason',
    source: 'Source',
    status: 'Status',
    date: 'Date',
    value: 'Value',
    quantity: 'Quantity',
    count: 'Count',
    sales: 'Sales',
    share: 'Share',
    prev: 'Previous',
    next: 'Next',
    page: 'Page {page} of {pages}',
    range: '{from}–{to} of {total}',
    emptyHint: 'Change the period or clear the filters.',
    vsPrevious: 'vs previous period',
    days: '{count} days',
    seeAll: 'See all',
    open: 'Open',
  },
  status: {
    OPEN: 'New',
    IN_PROGRESS: 'In analysis',
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    CLOSED: 'Closed',
  },
  source: {
    CORRECTION: 'Correction (KFS)',
    DRIVER: 'Driver / delivery',
    MANUAL: 'Manual entry',
  },
  category: {
    QUALITY: 'Quality',
    MISSING_IN_DELIVERY: 'Missing in delivery',
    MISSING_ON_DOCUMENT: 'Missing on document',
    WEIGHT_QUANTITY: 'Weight / quantity',
    WRONG_PRODUCT: 'Wrong product',
    EXPIRY_DATE: 'Expiry date',
    PRICE: 'Price',
    OTHER: 'Other',
  },
  complaints: {
    title: 'Complaints',
    description: 'Complaint register: sales corrections with a reason, delivery errors and manual entries. The handling status lives in NEXOPS — the ERP is not changed.',
    kpiCount: 'Complaints',
    kpiValue: 'Value',
    kpiOpen: 'New',
    kpiProgress: 'In analysis',
    searchPh: 'Correction number, customer, description…',
    reference: 'Document',
    detailTitle: 'Complaint {ref}',
    lines: 'Correction lines',
    reason: 'Correction reason',
    net: 'Net',
    noLines: 'Complaint without correction lines (delivery error or manual entry).',
    supplierFrom: 'receipt of {date}',
    noSupplier: 'no receipt before the sale',
    saleDate: 'Sale date',
    route: 'Route',
    driver: 'Driver',
    vehicle: 'Vehicle',
    document: 'Source document',
    descriptionLabel: 'Description',
    history: 'Handling history',
    noHistory: 'The status has not been changed in NEXOPS.',
    changeStatus: 'Change status',
    newStatus: 'New status',
    comment: 'Comment',
    commentRequired: 'A comment is required when rejecting.',
    statusSaved: 'Status saved.',
    monthClosed: 'Month closed in the management report — the status change does not alter the frozen report.',
    erpNote: 'The handling status is not written to InsERT.',
    handledBy: 'Handled by: {name}',
    caseCol: 'Complaint',
    kpiAvgHint: 'average {value}',
    insightWaiting: '{count} complaints are waiting to be handled (new and in review).',
    showOpen: 'Show new',
    allOfCustomer: 'All complaints of this customer',
    linesTotal: 'Lines total',
    mixTitle: 'Reasons mix',
    mixHint: 'Click a reason to narrow the list; click again to clear the filter.',
    ageCol: 'Age',
    sortBy: 'Sort by: {column}',
    selectAll: 'Select all on the page',
    selectRow: 'Select complaint',
    selected: 'Selected: {count}',
    bulkTitle: 'Change status of selected',
    bulkApply: 'Change status',
    bulkDone: 'Changed: {updated}, skipped: {skipped}.',
    bulkSkippedHint: 'Skipped when the current status does not allow the change or the case changed meanwhile.',
    bulkClear: 'Clear selection',
    prevCase: 'Previous complaint',
    nextCase: 'Next complaint',
    position: '{index} of {count} on the page',
    quickStatus: 'Quick status change',
    openFor: 'waiting {count} days',
  },
  analytics: {
    title: 'Complaint analytics',
    description: 'Complaints over time, share in sales (invoices, with regular customers’ receipts), products, reasons, customers and cost by supplier of the goods.',
    kpiShare: 'Share in sales',
    kpiSales: 'Net sales',
    receiptsHint: 'incl. receipts {value}',
    trend: 'Complaints over time',
    trendValue: 'Complaint value',
    trendShare: 'Share in sales (%)',
    byCategory: 'By reason',
    bySource: 'By source',
    products: 'Most complained products',
    complaintsCol: 'Corrections',
    pctOfSales: '% of product sales',
    customers: 'Customers with the highest complaint value',
    suppliers: 'Cost of complaints by supplier of the goods',
    suppliersHint: 'Supplier = last goods receipt of the product before the sale date. Value = correction lines with a reason.',
    unknownSupplier: 'No receipt before the sale',
    linesCol: 'Lines',
    productsCol: 'Products',
    trendHint: 'Bars: complaint value · line: share in net sales.',
    drillHint: 'Click a cause to see these complaints in the register.',
    bySourceHint: 'Where the complaint comes from: ERP correction, route report or manual entry.',
    productsHint: 'Correction lines with a reason, without services (bonuses, retro). Click a row to open the register.',
    pctOfSalesShort: '% of sales',
    casesCount: '{count} cases',
    insightTop: 'The costliest cause is “{category}” — {share} of the complaint value in the period.',
    showInRegister: 'Show in register',
    deltaHint: 'vs {from} – {to}',
    paretoTitle: 'Products Pareto (80/20)',
    paretoHint: '{top} of {products} complained products ({share}) make 80% of the complaint cost.',
    paretoCum: 'Cumulative share',
    heatTitle: 'Reasons month by month',
    heatHint: 'The darker the cell, the higher the value. Click a cell to open these complaints in the register.',
    heatValue: 'Value',
    heatCount: 'Count',
    ownersTitle: 'Sales reps',
    ownersHint: "Complaints of the rep's customers and their share in those customers' sales.",
    noOwner: 'Customers without an owner',
    customersCol: 'Customers',
  },
  events: {
    title: 'Quality events',
    description: 'Sorting of batches at receipt, complaints to suppliers, process events — with the rejected quantity and the corrective action.',
    add: 'New event',
    edit: 'Edit event',
    type: 'Type',
    checked: 'Checked',
    rejected: 'Rejected',
    rejectedPct: '% rejected',
    unit: 'Unit',
    descriptionLabel: 'Description',
    cause: 'Cause',
    action: 'Corrective action',
    responsible: 'Responsible',
    productName: 'Product outside the catalogue',
    kpiOpen: 'Open',
    kpiProgress: 'In progress',
    kpiClosed: 'Closed',
    kpiRejected: 'Rejected quantity',
    kpiSorting: 'Sorted batches',
    descriptionRequired: 'Description is required (min. 3 characters).',
    removeConfirm: 'Delete the event?',
    sortingHint: 'Sorting: enter the checked and rejected quantity — the rejection rate is calculated.',
    searchPh: 'Description, cause, action…',
    eventCol: 'Event',
    productSupplier: 'Product / supplier',
    rejectedCol: 'Rejected',
    rejectedOf: '{rejected} of {checked}',
    actionShort: 'Action',
    emptyHint: 'Record the first event — e.g. sorting a batch at goods receipt.',
    badNumber: 'Quantities must be non-negative numbers.',
    tooMany: 'More rejected than checked — correct the quantities.',
    viewList: 'List',
    viewBoard: 'Board',
    trendTitle: 'Events over time',
    trendHint: 'Bars: events by type · line: rejected % at receipt.',
    noActionPill: 'No corrective action',
    kpiNoAction: 'No action',
    kpiRejectedPct: 'Rejected at receipt',
    openFor: 'open {count} d',
    moveTo: 'Move: {status}',
    moved: 'Event moved.',
    boardEmpty: 'No events',
    boardTruncated: 'The board shows the {shown} newest of {total} — narrow the filters.',
    needsAction: 'no corrective action',
  },
  eventType: {
    RECEIPT_SORTING: 'Sorting at receipt',
    SUPPLIER_COMPLAINT: 'Complaint to supplier',
    PROCESS: 'Process event',
    OTHER: 'Other',
  },
  eventStatus: {
    OPEN: 'Open',
    IN_PROGRESS: 'In progress',
    CLOSED: 'Closed',
  },
  suppliers: {
    title: 'Suppliers',
    description: 'Cost of complaints attributed to the supplier of the goods, quality events and agreements with the supplier (feedback after complaints).',
    searchPh: 'Search supplier…',
    complaintValue: 'Complaint cost',
    events: 'Events',
    notes: 'Agreements',
    lastReceipt: 'Last receipt',
    lastNote: 'Last agreement',
    open: 'Agreements',
    notesTitle: 'Agreements: {name}',
    noNotes: 'No agreements with this supplier.',
    addNote: 'Add entry',
    kind: 'Kind',
    text: 'Text',
    followUp: 'Follow-up date',
    textRequired: 'Text is required (min. 3 characters).',
    kpiCost: 'Complaint cost',
    costShort: 'Cost',
    kpiWithCost: 'Suppliers with complaints',
    kpiOf: 'of {count} active in the period',
    insightTop: '{name} accounts for {share} of the complaint cost in the period.',
    lastReceiptShort: 'last receipt {date}',
    noReceipt: 'no receipt',
    ofTotal: '{share} of total',
    showEvents: 'Quality events of this supplier',
    textPh: 'What was agreed with the supplier, e.g. sorting batches before shipping…',
    noteSaved: 'Entry added.',
    removeConfirm: 'Delete the entry?',
    kpiPurchases: 'Purchases (PZ)',
    kpiCostPct: 'Cost / purchases',
    purchasesCol: 'PZ purchases',
    costPctCol: 'Cost / purchases',
    rejectedPctCol: 'Rejected',
    gradeCol: 'Grade',
    gradeHint: 'Grade = the worse of: complaint cost as % of purchases (A < 1%, B < 2.5%, C < 5%; counted from 10k PLN of purchases in the period) and rejected % at receipt (A < 2%, B < 5%, C < 10%).',
    quadrantTitle: 'Supplier map',
    quadrantHint: 'Suppliers with purchases from 10k PLN. Horizontal: purchases in the period (log scale) · vertical: complaint cost as % of purchases · size: cost. Click a point to open the supplier.',
    profileTrend: 'Purchases and complaint cost over time',
    profileProducts: 'Complained products of this supplier',
    profileEvents: 'Recent events',
    noProducts: 'No complained products in the period.',
    receiptsCount: '{count} PZ',
    overdueCount: '{count} overdue',
    nextFollowUp: 'due {date}',
    tabOverview: 'Overview',
    tabNotes: 'Agreements',
    insightGrade: '{count} suppliers have grade D (critical) in the period.',
    showGradeD: 'Show grade D',
  },
  noteKind: {
    NOTE: 'Note',
    AGREEMENT: 'Agreement',
  },
  overview: {
    title: 'Quality dashboard',
    description: 'What needs attention now: complaints to handle, open events, follow-ups with suppliers and what grows against the previous period.',
    kpiBacklog: 'To handle',
    backlogValue: 'value {value}',
    backlogTitle: 'Handling queue',
    backlogHint: 'New and in-analysis complaints (any period), oldest first.',
    backlogEmpty: 'All complaints are handled.',
    showBacklog: 'Whole queue in the register',
    trendTitle: 'Complaint value and share in sales',
    categoriesTitle: 'Reasons: now and before',
    categoriesHint: 'Bar = current period, marker = previous period of the same length.',
    moversTitle: 'What grows',
    moversHint: 'Largest growth of complaint value against the previous period.',
    moversProducts: 'Products',
    moversCustomers: 'Customers',
    moversEmpty: 'Nothing grows against the previous period.',
    was: 'was {value}',
    eventsTitle: 'Open events',
    eventsHint: 'Oldest open and in progress · {count} without a corrective action.',
    eventsEmpty: 'No open events.',
    rejectedPeriod: 'Rejected at receipt in the period: {value}',
    followUpsTitle: 'Supplier follow-ups',
    followUpsHint: 'Overdue and due within 14 days. A follow-up is handled once a newer entry is written for the supplier.',
    followUpsEmpty: 'No follow-ups to watch.',
    overdue: 'overdue {count} d',
    dueToday: 'today',
    dueIn: 'in {count} d',
    insightAging: '{count} complaints have been waiting more than 30 days.',
    insightUp: 'The share of complaints in sales grew by {delta} against the previous period.',
    insightDown: 'The share of complaints in sales fell by {delta} against the previous period.',
    showQueue: 'Show the queue',
    goAnalytics: 'Analytics',
    goComplaints: 'Complaint register',
    goEvents: 'Events',
    goSuppliers: 'Suppliers',
  },
  aging: {
    D0_7: 'up to 7 days',
    D8_30: '8–30 days',
    D31_90: '31–90 days',
    D90_PLUS: 'over 90 days',
  },
  grade: {
    A: 'Very good',
    B: 'Good',
    C: 'Needs work',
    D: 'Critical',
    none: 'Not graded',
  },
};
